import React, { useId } from 'react';
import { SparkleGradient } from '../../ui/Spinner/SparkleGradient';
import { SPARKLE_PATH, SPARKLE_VIEW_BOX } from '../../ui/Spinner/sparklePath';

export const IconAI: React.FC<{ className?: string }> = ({ className }) => {
    const gradientId = useId();

    return (
        <svg viewBox={SPARKLE_VIEW_BOX} fill={`url(#${gradientId})`} xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
            <SparkleGradient id={gradientId} />
            <path d={SPARKLE_PATH} />
        </svg>
    );
};
